function teamsBody(teamIdsOrBody) {
    if (Array.isArray(teamIdsOrBody)) return { teamIds: teamIdsOrBody };
    return teamIdsOrBody || {};
}

function assignmentBody(assignmentOrMembers) {
    if (Array.isArray(assignmentOrMembers)) return { members: assignmentOrMembers };
    return assignmentOrMembers || { members: [] };
}

export function teamAssociationApiMethods(client, basePath) {
    return {
        async getRelatedTeams(id, params = {}) {
            const response = await client.get(`${basePath}/${id}/teams`, { params });
            return response.data;
        },
        async getExecutionPlan(id) {
            const response = await client.get(`${basePath}/${id}/teams/execution-plan`);
            return response.data;
        },
        async updateExecutionPlan(id, body) {
            const response = await client.patch(`${basePath}/${id}/teams/execution-plan`, body || {});
            return response.data;
        },
        async addTeams(id, teamIdsOrBody) {
            const response = await client.post(`${basePath}/${id}/teams`, teamsBody(teamIdsOrBody));
            return response.data;
        },
        async copyTeamsFromLinked(id) {
            const response = await client.post(`${basePath}/${id}/teams/copy-from-linked`);
            return response.data;
        },
        async removeTeam(id, teamId) {
            const response = await client.delete(`${basePath}/${id}/teams/${teamId}`);
            return response.data;
        },
        async updateAssignment(id, assignmentId, assignmentOrMembers) {
            const response = await client.patch(
                `${basePath}/${id}/team-assignments/${assignmentId}`,
                assignmentBody(assignmentOrMembers),
            );
            return response.data;
        },
        async removeAssignment(id, assignmentId) {
            const response = await client.delete(`${basePath}/${id}/team-assignments/${assignmentId}`);
            return response.data;
        },
        async getRrLinkCandidates(id, params = {}) {
            const response = await client.get(`${basePath}/${id}/rr-link-candidates`, { params });
            return response.data;
        },
        async addDutyDefinitions(id, body) {
            const response = await client.post(`${basePath}/${id}/duty-definitions`, body || {});
            return response.data;
        },
        async createAndLinkDutyDefinition(id, body) {
            const response = await client.post(`${basePath}/${id}/duty-definitions/create`, body || {});
            return response.data;
        },
        async removeDutyDefinition(id, dutyDefinitionId) {
            const response = await client.delete(`${basePath}/${id}/duty-definitions/${dutyDefinitionId}`);
            return response.data;
        },
    };
}
